import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import {
  ActionPerformed,
  PushNotifications,
  PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications';
import { UtilsService } from './utils.service';
import { BadgeService } from './badge.service';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private isInitialized = false;
  private currentToken: string = null;

  constructor(
    private http: HttpClient,
    private utils: UtilsService,
    private router: Router,
    private badgeService: BadgeService
  ) {}

  async initPush() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;

    try {
      this.setupListeners();

      let permission = await PushNotifications.checkPermissions();
      if (permission.receive !== 'granted') {
        permission = await PushNotifications.requestPermissions();
      }

      if (permission.receive === 'granted') {
        await PushNotifications.register();
      } else {
        console.warn('Push notification permission not granted:', permission.receive);
      }
    } catch (error) {
      console.error('Error initializing push notifications:', error);
    }
  }

  async clearBadge() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    await this.badgeService.setBadge(0);
  }

  private setupListeners() {
    PushNotifications.removeAllListeners().catch(() => {});

    PushNotifications.addListener('registration', (token: Token) => {
      console.log('Push registration successful, token:', token.value);
      if (token?.value && token.value !== this.currentToken) {
        this.currentToken = token.value;
        this.sendTokenToServer(token.value);
      }
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Push registration error:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
      console.log('Push notification received:', JSON.stringify(notification));
      this.utils.sound('toggle');
    });

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
      console.log('Push action performed:', JSON.stringify(notification.notification));
      const data = notification.notification?.data;
      if (data) {
        const targetUrl = data.app_url || data.url || data.link;
        if (targetUrl) {
          const path = targetUrl.replace(/https?:\/\/[^\/]+/i, '');
          if (path) {
            this.router.navigateByUrl(path);
          }
        }
      }
    });
  }

  private sendTokenToServer(token: string) {
    const data = {
      registration_id: token,
      cloud_message_type: 'FCM',
    };
    const url = this.utils.getUrl('rest:device-fcm-list');

    console.log('Registering token with server:', token, url);

    this.http.post(url, data).subscribe({
      next: (resp) => console.log('Device registered successfully with backend:', resp),
      error: (err) => console.error('Failed to register device token with backend:', err),
    });
  }
}

